<div class="card flex flex-col sm:mr-2">
  <div class="p-gutter flex-auto max-w-[1000px] flex flex-col">
    <h3 class="body-2 m-0 shrink-0">Operations</h3>

    <div class="operations-scroll mt-4 flex-1 overflow-auto">
      <div #operationOriginRef class="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-6 g-3"
        [ngClass]="operations.length>4?'row-cols-lg-6':'row-cols-lg-4'">
        <span *ngFor="let operation  of operations" class="cursorP col">
          <a (click)="processOp(operation.route,operationOriginRef)"
            [class.disabled]="this.operationStatus.isOperationDisabled(operation.route,operation.id)"
            class="text-dark cursorP pt-3 text-center hover:bg-primary/10 hover:text-primary trans-ease-out rounded block no-underline">
            <mat-icon [svgIcon]="operation.icon" class="icon-xl" color="primary"></mat-icon>
            <div class="body-2 cursorP mt-2">{{ operation.label }}</div>
          </a>
        </span>
      </div>
    </div>
  </div>
</div>